export { getStroke } from './getStroke'
